export { getStroke } from './getStroke'
